import { useContext, useState, useRef, useEffect } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import LeftMenu from '../../components/leftMenu/index.js';
import './index.css';
import Replicates from '../../components/replicates/index.js';
import Backup from '../../components/backup';
import DownloadIcon from '@mui/icons-material/Download';
import { SaveReanimateFile } from "../../helpers/fileManager";
import { DownloadPackHTML, DownloadPackImage } from '../../helpers/downloadPack.js'
import { useAuth } from '../../hooks/useAuth'
import FlashOnIcon from '@material-ui/icons/FlashOn';
import CodeIcon from '@mui/icons-material/Code';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import RightMenu from '../../components/rightMenu/index.js';
import Video from '../../components/video';
import { ObjectToHtml, CreateHash, base64ToBlob } from '../../helpers/formaterBanner'
import { AuthValidatorContext } from '../../contexts/auth';
import { Compress } from '../../helpers/fileManager';
import { GetBannerSize } from '../../helpers/fileManager.js';
import Preview from '../../components/preview';
import { CreatePreview } from '../../services/auth.js';
import { getOriginalAsset} from '../../helpers/assets';
import { convertBlobToBase64 } from '../../helpers/fileManager';

function Dashboard() {
  const {
    master,setMaster,
    setOpenReplicaContainer,
    listaReplicas, setListaReplicas,
    showStep,
    videoModal, setVideoModal,
    openReplicaContainer,
    setShowStep,
    setLoading,
    fullScreenLeft, setFullScreenLeft,
    fullScreenRight, setFullScreenRight,
    mirrorActive, setMirrorActive,
    imageFormat, setPrinting, printStages,
    previewGridActive, setPreviewGridActive,
    previewGridHorizontal, setPreviewGridHorizontal,
    setError,
    setMessage, assets, setAssets
  } = useContext(BannerContext);
  const { recordHash } = useAuth();
  const [ listPreview, setListPreview ] = useState([]);
  const { tokenLocalStorage, allowPack, setAllowPack } = useContext(AuthValidatorContext);

  
  useEffect(() => {
    const handleListPreview = (event) => {
      let newListPreview = [JSON.parse(JSON.stringify(master))];
      listaReplicas.forEach(replica => {
        newListPreview.push(JSON.parse(JSON.stringify(replica)));
      });
      setListPreview(newListPreview);

    };

    handleListPreview();
  }, [previewGridActive] );

  function AllowedAccess(access) {
    if (!access) {
      setAllowPack(false);
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis!",
          lista: "",
          show: true
        }
      )
    }
  }

  async function saveFile(type) {
    try {
      if (mirrorActive) {
        if (fullScreenRight) {
          setMirrorActive(!mirrorActive);
          setOpenReplicaContainer(!openReplicaContainer);
          setFullScreenRight(!fullScreenRight)
        } else {
          setMirrorActive(!mirrorActive);
          setOpenReplicaContainer(!openReplicaContainer);
        }
      }
      if (!disabled) {      
        let copyShowStep = JSON.parse(JSON.stringify(showStep));
        copyShowStep.forEach(element => {
            element.show = true;
        });
        setShowStep(copyShowStep);
        var res = null;
        switch(type) {
          case "reanimate":
            SaveReanimateFile(master, assets, listaReplicas);
            res = { allowed_access: true };
            break;
          case "html":
            setPrinting(true);
            setLoading({show: true, progress: false});
            res = await recordHash(master, listaReplicas, "html");
            if (res) await DownloadPackHTML(master, assets, listaReplicas, imageFormat, printStages);
            setPrinting(false);
            setLoading({show: false, progress: false});
            break;
          case "image":
            setLoading({show: true, progress: false});
            res = await recordHash(master, listaReplicas, "estatico");
            if (res) await DownloadPackImage(master, assets, listaReplicas, imageFormat);
            setLoading({show: false, progress: false});
            break;
          default:
            break;
        }
        AllowedAccess(res.allowed_access);
      }
    } catch(error) { console.log(error)}
  }

  async function updateB64() {
    setLoading(true);
    var elements = window.psdTreeUpdate;
    var copyMaster = JSON.parse(JSON.stringify(master));
    var copyListaReplicas = JSON.parse(JSON.stringify(listaReplicas));
    var listAssets = JSON.parse(JSON.stringify(assets));
    
    try {
      if (!listAssets || listAssets.length === 0 || listAssets === null || listAssets === undefined || listAssets === "undefined") {
        listAssets = [];
        master.elements.forEach(element => {
          const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
          if (index === -1) {
            if (element.properties.background) {
              listAssets.push({
                uuid: element.properties.asset,
                data: element.properties.background
              });
            } else if (element.properties.originalBackground) {
              listAssets.push({
                uuid: element.properties.asset,
                data: element.properties.originalBackground
              });
            } else if (element.properties.blob) {
              convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: b64
                });
              });
            }
          }
        });
  
        listaReplicas.forEach(replica => {
          replica.elements.forEach(element => {
            const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
            if (index === -1) {
              if (element.properties.originalBackground) {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: element.properties.originalBackground
                });
              } else if (element.properties.blob) {
                convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                  listAssets.push({
                    uuid: element.properties.asset,
                    data: b64
                  });
                });
              } else if (element.properties.background) {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: element.properties.background
                });
              }
            }
          });
        })
      }
    } catch (error) {
      console.log('Error ao processar assets com lista vazia', error);
    }

    for (var i = 0; i < elements.length; i++) {
      let newElement = elements[i];
      let index = -1;
      for (var j = 0; j < copyMaster.elements.length; j++) {
        if (copyMaster.elements[j].id === newElement.id) {
          console.log('copyMaster.elements[j].id')
          console.log(copyMaster.elements[j].id)
          index = listAssets.findIndex(obj => obj.uuid === copyMaster.elements[j].properties.asset);
          if (index === -1) continue;
          listAssets[index].data = newElement.b64;
          const blob = base64ToBlob(newElement.b64);
          const blobUrl = URL.createObjectURL(blob);
          copyMaster.elements[j].properties.background = newElement.b64;
          copyMaster.elements[j].properties.originalBackground = newElement.b64;
          copyMaster.elements[j].properties.blob = blobUrl;
          copyMaster.elements[j].properties.width = newElement.width;
          copyMaster.elements[j].properties.height = newElement.height;
        }
      }
      copyMaster.html = ObjectToHtml(copyMaster, true);
      const html = ObjectToHtml(copyMaster);
      copyMaster.size = GetBannerSize(html);
      copyMaster.hash = CreateHash(copyMaster);

      for (var w = 0; w < copyListaReplicas.length; w++) {
        const replicas = copyListaReplicas[w];
        replicas.hash = CreateHash(replicas);
        for (var k = 0; k < replicas.elements.length; k++) {
          if (replicas.elements[k].id === newElement.id) {
            replicas.elements[k].properties.width = newElement.width;
            replicas.elements[k].properties.height = newElement.height;
            replicas.elements[k].properties.background = newElement.b64;
            replicas.elements[k].properties.originalBackground = newElement.b64;
            const blob = base64ToBlob(newElement.b64);
            const blobUrl = URL.createObjectURL(blob);
            replicas.elements[k].properties.blob = blobUrl;
          }
        }
        replicas.html = ObjectToHtml(replicas, true);
        const html = ObjectToHtml(replicas);
        replicas.size = GetBannerSize(html);
      }
    }
    setAssets(listAssets);
    setMaster(copyMaster);
    setListaReplicas(copyListaReplicas);
    setLoading(false);
  }

  var disabled = true;
  listaReplicas.forEach(element => {
    if (element.pack) {
      disabled = false;
    }
  });

  const [isWindowDownOpen, setIsWindowDownOpen] = useState(false);
  const windowRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (windowRef.current && !windowRef.current.contains(event.target)) {
        setIsWindowDownOpen(false)
      }
    };

      document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
  }, [] });

  const handleWindowDown = () => {
    setIsWindowDownOpen(!isWindowDownOpen)
  };

  const handleClickDownloadRean = () => {
    saveFile("reanimate")
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadHTML = async () => {
    if (allowPack) {
      saveFile("html")
    } else {
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis!",
          lista: "",
          show: true
        }
      )
    }
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadImg = async () => {
    if (allowPack) {
      saveFile("image")
    } else {
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis!",
          lista: "",
          show: true
        }
      )
    }
    setIsWindowDownOpen(false);
    
  };

  const handleClickDownloadVideo = async () => {    
    if (allowPack) {
      setVideoModal(true);
    } else {
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis!",
          lista: "",
          show: true
        }
      )
    }
  };

  /**
   * 
   * @returns string
   */
  const [divWidthL, setDivWidthL] = useState('340px');
  const [divWidthR, setDivWidthR] = useState('340px');
  const [divWidthM, setDivWidthM] = useState('100vw');
  const [divWidthMM, setDivWidthMM] = useState('100vw');
  const [divPaddingMM, setDivPaddingMM] = useState('0');

  useEffect(() => {
    function handleResize() {
      if (!fullScreenLeft) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidthL('340px');
        } else if (windowWidth >= 1600) {
          setDivWidthL('340px');
        } else if (windowWidth >= 1300) {
          setDivWidthL('240px');
        } else if (windowWidth >= 1200) {
          setDivWidthL('200px');
        } else {
          setDivWidthL('340px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft]);

  useEffect(() => {
    function handleResize() {
      if (!fullScreenRight) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidthR('340px');
        } else if (windowWidth >= 1600) {
          setDivWidthR('290px');
        } else if (windowWidth >= 1300) {
          setDivWidthR('240px');
        } else if (windowWidth >= 1200) {
          setDivWidthR('200px');
        } else {
          setDivWidthR('340px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenRight]);

  useEffect(() => {
    function handleResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1280 && windowWidth <= 1359) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('90vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1080px');
            setDivWidthMM('950px');
            setDivPaddingMM('70px');
          } else {
            setDivWidthM('850px');
            setDivWidthMM('750px');
            setDivPaddingMM('70px');
          }
        } else if (windowWidth >= 1360 && windowWidth <= 1439) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1110px');
            setDivWidthMM('1000px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('960px');
            setDivWidthMM('750px');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1440 && windowWidth <= 1599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1190px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1140px');
            setDivWidthMM('58%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1600 && windowWidth <= 1699) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1300px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1200px');
            setDivWidthMM('56%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1700 && windowWidth <= 1799) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1300px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1200px');
            setDivWidthMM('59%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1800 && windowWidth <= 1919) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('75%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('60%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 1920 && windowWidth <= 1999) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('76%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('58%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2000 && windowWidth <= 2099) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1570px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('60%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2100 && windowWidth <= 2299) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1700px');
            setDivWidthMM('79%');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('62%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2300 && windowWidth <= 2399) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('93vw');
            setDivPaddingMM('70px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('1850px');
            setDivWidthMM('2000px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('1720px');
            setDivWidthMM('65%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2400 && windowWidth <= 2699) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2200px');
            setDivWidthMM('2100px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('67%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 2700 && windowWidth <= 3099) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2200px');
            setDivWidthMM('2200px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('70%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3100 && windowWidth <= 3399) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2600px');
            setDivWidthMM('2600px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('74%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3400 && windowWidth <= 3599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('2900px');
            setDivWidthMM('2900px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('77%');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3600 && windowWidth <= 3839) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('95vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('3100px');
            setDivWidthMM('3100px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('2600px');
            setDivWidthMM('2600px');
            setDivPaddingMM('60px');
          }
        } else if (windowWidth >= 3840) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidthM('100vw');
            setDivWidthMM('96vw');
            setDivPaddingMM('60px');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivWidthM('3400px');
            setDivWidthMM('3350px');
            setDivPaddingMM('60px');
          } else {
            setDivWidthM('3200px');
            setDivWidthMM('3000px');
            setDivPaddingMM('60px');
          }
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  const handleShowGrid = () => {
		setPreviewGridActive(!previewGridActive)
	};

  const handleGridOrientation = () => {
		setPreviewGridHorizontal(!previewGridHorizontal)
	};

  const handleCreatePreview = async () => {

    setLoading({show: true, progress: false});
		const res = await CreatePreview(tokenLocalStorage, listPreview)

    const url = window.location.origin;

    if(res.status === true) {

      let message = 'Preview criado com cucesso, acesse com a URL: ';
      //message += url + "/preview/" + res.id;

      setMessage(
        {
          mensagem: message,
          link: url + "/preview/" + res.id,
          show: true
        }
      )
    } else {
      setError(
        {
          mensagem: "Ocorreu um erro ao tentar salvar o preview",
          lista: "",
          show: true
        }
      )
    }

    setLoading({show: false, progress: false});
	};

  return(
    <div className="root-dashboard">
      { videoModal ? <Video/> : <></> }

      {previewGridActive ? 
      <div className="previewGridBg">
        {listPreview.length > 0 ?
      <div className="previewGridWindowOut">
        <div className='previewGridTop'>
          <div className='previewGridOrientationButton' onClick={handleGridOrientation}>Alterar orientação</div>
          <div className='previewGridCloseButton' onClick={handleShowGrid}>Fechar</div>
        </div>
        <div className="previewGridWindowIn" style={{flexFlow: previewGridHorizontal ? 'column wrap' : 'row wrap'}}>
            {listPreview.map((item) =>
              <div className="container-preview-r2" key={Math.random()}>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                  <span>{item.width}x{item.height}</span>
                  <Preview {...item} type="replica" className="preview-container" />
                </div>
              </div>
            )}
        </div>

        <div style={{position: 'absolute', right: '15px', bottom: '15px'}}>
          <span className="gridButton"
            style={{cursor: 'pointer'}}
            onClick={handleCreatePreview}>Salvar Preview</span>
        </div>
      </div>  
          :
          <div className="previewGridWindow2">
            <div className='previewGridTop'>
              <div className='previewGridCloseButton' onClick={handleShowGrid}>Fechar</div>
            </div>
            <span className='messageSelectFormat' style={{margin: '0 auto', lineHeight: '25px', fontSize: '16px'}}>Selecione ao menos um formato para visualizar</span>
          </div>  
        }
      </div>
      :
      <div></div>}

      <LeftMenu/>
      <div className='collapseLeftMenu'
        style= {{
        left: fullScreenLeft ? '-5px' : divWidthL,
        transform: fullScreenLeft ? 'scaleX(-1)' : 'scaleX(1)',
        transition: 'left 500ms'
        }}
        onClick={() => setFullScreenLeft(!fullScreenLeft)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <g id="Group_733" data-name="Group 733" transform="translate(-5890 9764)">
            <g id="Ellipse_33" data-name="Ellipse 33" transform="translate(5890 -9764)" fill="#68498C" stroke="#c6ade4" strokeWidth="1">
              <circle cx="10" cy="10" r="10" stroke="none"/>
              <circle cx="10" cy="10" r="9.5" fill="none"/>
            </g>
            <path id="Path_538" data-name="Path 538" d="M0,0,4.5,5.143,9,0" transform="translate(5901.665 -9758.474) rotate(90)" fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      </div>
      <div className='centerPart' style={{width: mirrorActive ? divWidthM : divWidthMM, maxWidth: divWidthM, transition: 'width 500ms', paddingLeft: mirrorActive ? '0' : divPaddingMM}}>
        <div style={{display: 'flex', height: '77px', justifyContent: 'flex-end', alignItems: 'center', position: 'relative'}}>
          <div className='containerButtons'>
            <div style={{display: 'flex', margin: fullScreenLeft && fullScreenRight && listaReplicas.length > 8 ? '55px 30px 0 0' : !(fullScreenLeft && fullScreenRight) && listaReplicas.length > 6 ? '40px 30px -20px 0' : '0 30px 0 0'}}>
              <button className='uploadButton' onClick={() => document.getElementById('file-dropzone-updatepsd').click()}>Atualizar PSD</button>
              <button
                onClick={handleWindowDown}
                disabled={listaReplicas.length === 0}
                className='downloadButton'
                style={{cursor: listaReplicas.length === 0 ? 'not-allowed' : 'pointer'}}
                >
                  Download 
                  <DownloadIcon style={{margin: '0 -5px 0 10px'}}/>
              </button>
              {isWindowDownOpen && (
                <div ref={windowRef} className='downloadWindow'>
                  <div onClick={handleClickDownloadRean} className='downRean'><FlashOnIcon className='flashIcon'/> Re.animate</div>
                  <div onClick={handleClickDownloadHTML} className='downHTML'><CodeIcon className='codeIcon'/> Pack HTML</div>
                  <div onClick={handleClickDownloadImg} className='downImg'><CropOriginalIcon className='cropIcon'/> Pack Imagem</div>
                  <div onClick={handleClickDownloadVideo} className='downImg'><CropOriginalIcon className='cropIcon'/> Pack Video</div>
                </div>
              )}
              <div id='PsdUpdate' style={{display: 'none'}} onClick={() => updateB64()}></div>
            </div>
          </div>
        </div>
        <Replicates/>
      </div>
      <div className='collapseRightMenu'
        style= {{
        right: fullScreenRight ? '-5px' : divWidthR,
        transform: fullScreenRight ? 'scaleX(1)' : 'scaleX(-1)',
        transition: 'right 200ms'
        }}
        onClick={() => setFullScreenRight(!fullScreenRight)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <g id="Group_733" data-name="Group 733" transform="translate(-5890 9764)">
            <g id="Ellipse_33" data-name="Ellipse 33" transform="translate(5890 -9764)" fill="#68498C" stroke="#c6ade4" strokeWidth="1">
              <circle cx="10" cy="10" r="10" stroke="none"/>
              <circle cx="10" cy="10" r="9.5" fill="none"/>
            </g>
            <path id="Path_538" data-name="Path 538" d="M0,0,4.5,5.143,9,0" transform="translate(5901.665 -9758.474) rotate(90)" fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      </div>
      <Backup banner={master} />
      <RightMenu/>
    </div>
  )
}

export default Dashboard;